import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import PortPanel from "@/components/panel/PortPanel";
import RouteRange from "@/components/panel/RouteRange";
import RouteFactorChartPanel from "@/components/panel/RouteFactorChartPanel";
import WeatherChartPanel from "@/components/panel/WeatherChartPanel";
import DetectionImagePanel from "@/components/panel/DetectionImagePanel";
import ImageryLegend from "@/components/panel/ImageryLegend";
import DetectionInformationPanel from "@/components/panel/DetectionInformationPanel";
import styles from "./index.module.less";

function RightPanelContainer() {
  const mode = useSelector((state) => state.panel.mode);
  return (
    <div className={styles.rightPanelContainer}>
      <PortPanel />
      {mode === "planning" ? (
        <Fragment>
          <RouteRange />
          <RouteFactorChartPanel />
          <WeatherChartPanel />
        </Fragment>
      ) : (
        <Fragment>
          <DetectionImagePanel />
          <ImageryLegend />
          <DetectionInformationPanel />
        </Fragment>
      )}
    </div>
  );
}

export default RightPanelContainer;
